import { Button, Form, Modal } from '@themesberg/react-bootstrap';
import React, { useState, useEffect } from 'react';
import EditableDropDown from '../../components/common/EditableDropdown';

const PerTripEditModal = ({
  show,
  handleClose,
  tripData,
  onSubmit,
  vendorsList,
}) => {
  const [totalAmount, setTotalAmount] = useState(tripData?.totalAmount);
  const [vendorDetails, setVendorDetails] = useState({
    vendorName: tripData?.driverInfo?.vendorName,
    vendorObjectId: tripData?.driverInfo?.vendorObjectId,
  });

  useEffect(() => {
    setVendorDetails({
      vendorName: tripData?.driverInfo?.vendorName,
      vendorObjectId: tripData?.driverInfo?.vendorObjectId,
    });
    setTotalAmount(tripData?.totalAmount);
  }, [tripData?.tripNumber]);

  return (
    <Modal show={show} centered onHide={handleClose} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Edit Amount - {tripData?.tripNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Total Amount</Form.Label>
          <Form.Control
            type="text"
            value={totalAmount}
            onChange={(e) => setTotalAmount(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Vendor Name</Form.Label>
          <EditableDropDown
            id={'vendor'}
            onChange={(e) =>
              setVendorDetails({
                vendorName: e.label,
                vendorObjectId: e.value,
              })
            }
            backgroundColor="#eaedf2"
            value={vendorDetails.vendorName}
            options={Object.values(vendorsList).map((item) => ({
              label: item.vendorName,
              value: item.objectId,
            }))}
            placeholder={'Select Vendor Name'}
          />
        </Form.Group>
        <Button
          className="mt-2"
          onClick={() => {
            onSubmit({
              ...tripData,
              tripId: tripData.objectId,
              totalAmount,
              vendorName: vendorDetails.vendorName,
              vendorObjectId: vendorDetails.vendorObjectId,
              type: 'perTrip',
            });
            handleClose();
          }}
        >
          Submit
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default PerTripEditModal;
